export default "__VITE_ASSET__43250542__"